export class People {
	constructor() {
		console.log("People ViewModel created");
	}
}